exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"WhyHost.css","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":true,"modules":true,"localIdentName":"[path][name]__[local]","minimize":false,"discardComments":{"removeAll":false}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/routes/whyhost/WhyHost.css
// module id = 3134
// module chunks = 8